export class  OrganiserLinks  {
    facebook?: string;
    twitter?: string;
    google?: string;
    googleplus?: string;
    picasa?: string;
    flickr?: string;
    youtube?: string;
    vimeo?: string;

    constructor() {
        this.facebook = undefined;
        this.twitter = undefined;
        this.google = undefined;
        this.googleplus = undefined;
        this.picasa = undefined;
        this.flickr = undefined;
        this.vimeo = undefined;
        this.youtube = undefined;
    }
};
   